import GiveItemContent from "../../../../../lib/html5-software-library/src/ranj/eng/content/dialog/GiveItemContent";
import AnimationFactory from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationFactory";
import AnimationOptions from "../../../../../lib/html5-software-library/src/ranj/ui/animation/AnimationOptions";
import AbstractCommand from "../../../core/application/AbstractCommand";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import ProgressModel from "../../progress/model/ProgressModel";
import PromiseUtil from "../../util/PromiseUtil";
import ConversationResultEvent from "../event/ConversationResultEvent";

export default class PlayConversationResultCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher  
     * @param {ProgressModel} progressModel 
     */
    constructor(dispatcher, progressModel) {
        super(dispatcher);

        this._progressModel = progressModel;

        this._handleConversationResultFinishedBound = this._handleConversationResultFinished.bind(this);
    }

    execute(evt) {
        /** @type {ScenarioPlayerEvent} */
        const data = evt.params.data;
        const { content, contentPlayer } = data;

        /** @type {GiveItemContent} */
        this._content = content;
        /** @type {NGTScenarioPlayer} */
        this._contentPlayer = contentPlayer;

        const conversationId = this._content.getItemID();
        const conversation = this._progressModel.getConversationProgressById(conversationId);

        this._conversationResultScreenSkin = this.openScreen(SkinKeyRegistry.CONVERSATION_RESULT_SCREEN_SKIN, {
            animationType: AnimationFactory.FADE_IN,
            animationOptions: new AnimationOptions(0, 450, createjs.Ease.sineInOut),
        }, {
            conversation,
        });

        this._dispatcher.addEventListener(ConversationResultEvent.FINISH, this._handleConversationResultFinishedBound);
    }

    async _handleConversationResultFinished(evt) {
        this._dispatcher.removeEventListener(ConversationResultEvent.FINISH, this._handleConversationResultFinishedBound);

        const transitionDuration = 450;
        this.closeScreen(this._conversationResultScreenSkin, {
            animationType: AnimationFactory.FADE_OUT,
            animationOptions: new AnimationOptions(0, transitionDuration, createjs.Ease.sineInOut),
        });

        await PromiseUtil.delay(transitionDuration);
        this._contentPlayer.contentCompleted(this._content);
    }
}